module.exports = __webpack_public_path__ + "img/video.703ade33.png";